import React, { useState } from 'react';
import { ColorRing } from 'react-loader-spinner';

import ListHeader from '../../../../../../components/ListHeader';
import EmployeesTable from './EmployeesTable';
import AddEmployeeModal from '../EmployeeModals/AddEmployeeModal';
import EmployeeModal from '../EmployeeModals/EmployeeModal';
import { EmployeeListFields } from '../../config/employeeFieldsConfig';
import useEmployeeList from '../../hooks/useEmployeesList';
import PaginationControls from './PaginationControls';
import EmployeeCardList from '../EmployeeCards/EmployeeCardList';

const EmployeeList = () => {
  const {
    employees,
    isLoading,
    currentPage,
    rowsPerPage,
    totalPages,
    setCurrentPage,
    setRowsPerPage,
    fetchEmployees,
  } = useEmployeeList();

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedEmployeeIndex, setSelectedEmployeeIndex] = useState(null);
  const [viewMode, setViewMode] = useState('table'); // State for toggling between "table" and "card" views

  const refreshData = () => {
    fetchEmployees(currentPage, rowsPerPage); // This should reload the employee list
  };

  const handleOpenEditModal = (id) => {
    const index = employees.findIndex((employee) => employee.id === id);
    if (index !== -1) {
      setSelectedEmployeeIndex(index); // Set the index of the employee
      setIsEditModalOpen(true);
    }
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  return (
    <div className="mx-4 px-4 h-screen w-full">
      <ListHeader
        title='Employee List'
        viewMode={viewMode}
        handleViewModeChange={handleViewModeChange} // Pass the handler
        handleOpenCreateModal={() => setIsAddModalOpen(true)}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div className="flex justify-center items-center">
          <ColorRing
            visible={isLoading}
            height="200"
            width="200"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
          />
        </div>
      )}

      {/* Display Table or Cards based on View Mode */}
      {!isLoading && employees.length > 0 && (
        <>
          {viewMode === 'table' ? (
            <EmployeesTable
              employeeFields={EmployeeListFields}
              employees={employees}
              handleOpenViewModal={handleOpenEditModal}
            />
          ) : (
            <EmployeeCardList
              employees={employees}
              employeeFields={EmployeeListFields}
              handleOpenViewModal={handleOpenEditModal}
            />
          )}
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={setCurrentPage}
            rowsPerPage={rowsPerPage}
            handleRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
          />
        </>
      )}

      {!isLoading && employees.length === 0 && (
        <div className="text-center text-gray-500 mt-6">
          No employees found.
        </div>
      )}

      {/* Modals */}
      {isEditModalOpen && (
        <EmployeeModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          employees={employees}
          currentIndex={selectedEmployeeIndex}
          refreshData={refreshData}
        />
      )}
      {isAddModalOpen && (
        <AddEmployeeModal
          open={isAddModalOpen}
          handleClose={() => setIsAddModalOpen(false)}
          refreshData={refreshData}
        />
      )}
    </div>
  );
};

export default EmployeeList;
